import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-oro bg-ciencia-light" data-id="element-110" data-mp="8mdmfcb6rh3m">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-111" data-mp="dfyg4s5qxox0">
        <p className="inline-block rounded-md bg-naranja px-2 py-0.5 font-sub text-sm font-extrabold leading-tight text-white" data-id="element-112" data-mp="icorj26lvwc3">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-2 font-display text-[1.75rem] uppercase leading-[1.08] tracking-wide text-noche sm:text-5xl" data-id="element-113" data-mp="refy098z0770">
          Comienza hoy desde cero y avanza a tu ritmo.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-2xl border-4 border-dashed border-noche bg-white text-noche" data-id="element-114" data-mp="2t7m6u5u62l7d">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block bg-white" data-id="element-115" data-mp="12n8n7xqgy4ns">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos y 5 bonos incluidos`} className="block w-full" data-id="element-116" data-mp="xup64qskore8" />
          </a>
          <div className="p-3" data-id="element-117" data-mp="oxoor43x7tka">
            <p className="font-sub text-sm font-extrabold uppercase leading-tight text-noche" data-id="element-118" data-mp="ouamrwz65mdd">
              {PRODUCT_NAME}
            </p>
            <p className="mt-1 inline-block rounded-md bg-oro px-2 py-0.5 font-display text-3xl uppercase leading-tight tracking-wide text-noche" data-id="element-119" data-mp="1gn1fvylk2uye">
              6 Tomos + 5 Bonos
            </p>
            <p className="mt-1 text-xs font-semibold text-noche/80 sm:text-sm" data-id="element-120" data-mp="17neehcsttp5c">
              🎁 Bonos valorados en{' '}
              <span className="line-through decoration-red-600 decoration-2" data-id="element-121" data-mp="17avja9lnoo4">{BONUS_TOTAL}</span>
            </p>

            <p className="mt-2 inline-block rounded-full bg-naranja px-3 py-0.5 font-sub text-xs font-extrabold uppercase text-white" data-id="element-122" data-mp="3sbiydz3azpzn">
              🔥 Oferta especial
            </p>
            <p className="mx-auto mt-1 w-fit rounded-xl border-2 border-noche bg-oro px-3 py-1 font-display text-5xl leading-none tracking-wide text-noche sm:text-6xl" data-id="element-123" data-mp="2mdky6c45u2l">
              <span className="text-2xl sm:text-3xl" data-id="element-124" data-mp="3oudc5rqtwkbp">Hoy:</span> {PRICE}
            </p>
            <p className="mt-1.5 text-xs font-semibold text-noche/80" data-id="element-125" data-mp="3b3rta31dkadt">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-126" data-mp="3fvt0vbnllcxi">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>
            <p className="mt-2.5 text-xs font-semibold text-noche/80" data-id="element-127" data-mp="363ncebwk1dn2">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}